import { render, staticRenderFns } from "./announcements_show.vue?vue&type=template&id=1c2b8356&scoped=true&"
import script from "./announcements_show.vue?vue&type=script&lang=js&"
export * from "./announcements_show.vue?vue&type=script&lang=js&"
import style0 from "./announcements_show.vue?vue&type=style&index=0&id=1c2b8356&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2b8356",
  null
  
)

export default component.exports